import React, {FC, useState} from "react"

import {LangLoader, FormattedMessage} from "@irati/utils/lang"
import History from "@irati/utils/history"
import {ONBOARDING} from "@irati-web/app/src/routeConfig"
import onboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"
import {UserTracking as tracking} from "@irati-tracking/onboarding"
import Modal from "@irati/ui/src/GenericModal"
import {H3, Body} from "@irati/ui/src/Typography"
import {User} from "@irati/types"
import image from "@irati/ui/images/welcomeUserOnboarding.svg"

interface Props {
  user: User
}

const SetDetailsModal: FC<Props> = ({user}) => {
  const [submit, setSubmit] = useState<Promise<any> | null>(null)

  const close = () => {
    tracking.welcomePopUpDismissed()
    const load = onboardingService.completeStep(user, OnboardingStep.SET_DETAILS)
    setSubmit(load)
    return load
  }

  const setDetails = () => {
    tracking.welcomePopUpGoToProfile()
    close().then(() => {
      History.push("/account/profile")
    })
  }

  if (!user) return null

  return (
    <LangLoader bucket={ONBOARDING}>
      <Modal
        show
        image={image}
        load={submit}
        onHide={close}
        onConfirm={setDetails}
        dismissButtonText="onboarding.setDetailsModal.close"
        proceedButtonText="onboarding.setDetailsModal.continue">
        <H3>
          <FormattedMessage id="onboarding.setDetailsModal.header" />
        </H3>
        <Body marginTop={1} marginBottom={4}>
          <FormattedMessage id="onboarding.setDetailsModal.content" />
        </Body>
      </Modal>
    </LangLoader>
  )
}

export default SetDetailsModal
